// File types allowed in document upload inputs (passed to the input's accept attribute)
const AcceptedUploadTypes =
  ".pdf,.jpg,.jpeg,.png,.tif,.tiff,.heic,.doc,.docx,.xls,.xlsx";

export default AcceptedUploadTypes;
